import { IconComponent } from './types';

const MinusIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={2}
    viewBox="0 0 10 2"
    fill="none"
    {...props}
  >
    <path stroke="currentColor" d="M0 .833h10" />
  </svg>
);
export default MinusIcon;
